import axios from 'axios';
import moment from 'moment';

/*
MitApiService - deals with setting up the token for the api to push volume data
*/
class MitApiKeyService {
  constructor() {

  }

  requestGetApiKey(options) {
    return new Promise ((resolve, reject) => {

      let url = new URL(window.location.origin+'/api/v1/admin/access');

      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          url.searchParams.append(prop, options[prop]);
        }
      }

      axios.get(url.pathname+url.search)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }

  requestGenerateKey(name) {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/admin/access/generate/'+name)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }


}

export default new MitApiKeyService();
